import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import { deleteSupplier, SuppliersAdd, suppliersRead, SupplierUpdate, updateSupplier } from '../Supplier';
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';
// mock
//import userList from '../_mock/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Nom', alignRight: false },
  { id: 'company', label: 'API Key', alignRight: false },
  { id: 'role', label: 'PeppolKey', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {



  const [USERLIST,setUserList]=useState([])
  const [currentLine,setCurrentLine]=useState({})
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);
  const [callDeleteUser,setCallDeleteUser]=useState({id:null,reply:null})
  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');
  const [newSupp,setNewSupp]=useState(null)
  const [updateSupp,setUpdateSupp]=useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(5);
 
  const deleteUser=(id)=>{
    console.log("DELEETE"+id)
    deleteSupplier(id).then(()=>
    suppliersRead().then(data=>setUserList(data.map(i=>({id:i[0],name:i[1],apiKey:i[2],status:i[3]||"active"}))))
    ).catch(()=>alert("Impossible de procéder à la suppression"))
    setCallDeleteUser({id:null,reply:null})
  }

  useEffect(()=>{
    suppliersRead().then(data=>setUserList(data.map(i=>({id:i[0],name:i[1],apiKey:i[2],status:i[3]||"active"})))
    )
  },[])

  const handleOpenMenu = (event,data) => {
    setCurrentLine(data)
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  const resultOfNew=(val)=>{
    if(val===true){
      suppliersRead().then(data=>setUserList(data.map(i=>({id:i[0],name:i[1],apiKey:i[2],status:i[3]||"active"}))))
    }

  }
  if(updateSupp){
    return(
      <>
      <Helmet>
        <title>Client | Update</title>
        </Helmet>
        <Container>
          <SupplierUpdate callback={()=>setUpdateSupp(null)} id={updateSupp} />
        </Container>
        </>
    )
  }
  if(newSupp){
    return(
    <>
      <Helmet>
        <title>Client | Création</title>
      </Helmet>
      <Container>
        <SuppliersAdd callback={resultOfNew}/>
      </Container>
    </>
    )
  }
  else{
  return (
    <>
      {callDeleteUser.id!=null && callDeleteUser.reply==null && (
        <Dialog open={true}
          onClose={(e)=>console.log(e)}
        >
          <DialogTitle>{`Confirmer vous la suppression de l'utilisateur ${currentLine.name}`}</DialogTitle>
          <DialogContent>
            <DialogContentText>{`Confirmer vous la suppression de l'utilisateur ${currentLine.name}`}</DialogContentText>
          </DialogContent>
          <DialogActions>
          <Button onClick={()=>setCallDeleteUser({id:null,reply:null})}>Annuler</Button>
          <Button onClick={deleteUser(currentLine.id)} autoFocus>
            Confirmer
          </Button>
        </DialogActions>
          
        </Dialog>
      )}
      <Helmet>
        <title> Clients | List </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Fiche client
          </Typography>
          <Button onClick={()=>setNewSupp(true)} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Nouveau
          </Button>
        </Stack>

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, name, apiKey, status, company, avatarUrl, isVerified } = row;
                    const selectedUser = selected.indexOf(name) !== -1;

                    return (

                      
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {name}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{apiKey}</TableCell>

                        <TableCell onClick={()=>{setUpdateSupp(id)}} align="left">{id}</TableCell>
                        <TableCell onClick={()=>updateSupplier({...row,status:status==="active"?"banned":"active"}).then(()=>{resultOfNew(true)})} align="left">
                          <Label color={(status === 'banned' && 'error') || 'success'}>{sentenceCase(status)}</Label>
                        </TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(event)=>{
                             event.stopPropagation();
                            handleOpenMenu(event,row)}
                            }>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={USERLIST.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={()=>updateSupplier({...currentLine,apiKey:uuidv4()}).then(()=>{resultOfNew(true)})}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          API Key
        </MenuItem>

        <MenuItem onClick={()=>setCallDeleteUser({id:currentLine.id,reply:null})} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  )};
}
